module.exports = __webpack_public_path__ + "static/21-b1a568e8b93e19d895046103fc478ffc.png";